import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { TextField, Grid, Button } from '@material-ui/core';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import * as Actions from './store/actions';
import '../course/CourseForm.css';
import * as validatorActions from '../../components/validator/store/actions'

const styles = theme => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: '80%',
    },
    textFieldSearch: {
        marginLeft: theme.spacing.unit,
        width: '95%',
    },
    button: {
        margin: theme.spacing.unit,
    },
    editor: {
        "min-height": "150px"
    },
    root: {
        backgroundColor: theme.palette.background.paper,
        width: 500,
    },
    readOnlyMargin: {
        marginLeft: '16px'
    },
    hiddenWhenEmptyValue: {
        display: 'none'
    },
});


class CompanyForm extends Component {
    state = {}

    handleTabChange = (event, value) => {
        this.setState({ majorTabValue: value });
    };

    handleChange = field_name => event => {

        let value = event.target.value;
        if (event.target.type === 'checkbox') {
            value = event.target.checked ? 1 : 0;
        }

        const update_data = {
            [field_name]: value
        }

        const validator = {
            field_name, value
        }

        this.props.runValidator(validator)
        this.props.updateCompanyForm(update_data);
    }

    disableButton = () => {
        this.setState({ canSubmit: false })
    }

    enableButton = () => {
        this.setState({ canSubmit: true })
    }

    render() {
        const { classes, view_type, theme, company, validator } = this.props;

        // Below function modifies component properties to get the desired appearance
        //      in the 'detail' view. Previously, we just set the TextField to 'disabled'
        //      which had the side effect of setting the text to a transparent gray.

        const InputProps = (view_type) => {
            switch (view_type) {
                case ('detail'): {
                    return {
                        readOnly: true,
                        disableUnderline: true,
                        className: this.props.classes.readOnlyMargin
                    }
                }
                default: {
                    return {}
                };
            }
        }

        // Constant below is simply a helper to go ahead and assign props that do
        //      not differ between the text fields without needing to repeat them.

        const sharedTextFieldProps = {
            InputProps: InputProps(view_type),
            variant: view_type === 'detail' ? "standard" : "outlined",
            margin: 'normal',
            className: classes.textField
        }

        return (
            <div className="p-24">
                <Grid container spacing={24}>
                    <Grid item xs={6}>
                        <form style={styles.insidePaper} autoComplete="off">
                            <Grid item xs={12}>
                                <TextField
                                    required
                                    id="CompanyName"
                                    label="Company Name"
                                    value={company.CompanyName}
                                    onChange={this.handleChange('CompanyName')}
                                    error={validator.filter(v => v.field_name === 'CompanyName')[0].error}
                                    helperText={validator.filter(v => v.field_name === 'CompanyName')[0].error_msg}
                                    {...sharedTextFieldProps}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    id="CompanyDescription"
                                    label="Company Description"
                                    value={company.CompanyDescription}
                                    onChange={this.handleChange('CompanyDescription')}
                                    {...sharedTextFieldProps}
                                    className={(company.CompanyDescription === (undefined || '') && view_type === 'detail') ? [classes.hiddenWhenEmptyValue, classes.textField].join(' ') : classes.textField}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    id="CompanyAddress"
                                    label="Company Address"
                                    value={company.CompanyAddress}
                                    onChange={this.handleChange('CompanyAddress')}
                                    {...sharedTextFieldProps}
                                    className={(company.CompanyAddress === (undefined || '') && view_type === 'detail') ? [classes.hiddenWhenEmptyValue, classes.textField].join(' ') : classes.textField}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    id="CompanyCity"
                                    label="Company City"
                                    value={company.CompanyCity}
                                    onChange={this.handleChange('CompanyCity')}
                                    {...sharedTextFieldProps}
                                    className={(company.CompanyCity === (undefined || '') && view_type === 'detail') ? [classes.hiddenWhenEmptyValue, classes.textField].join(' ') : classes.textField}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    id="CompanyState"
                                    label="Company State"
                                    value={company.CompanyState}
                                    onChange={this.handleChange('CompanyState')}
                                    {...sharedTextFieldProps}
                                    className={(company.CompanyState === (undefined || '') && view_type === 'detail') ? [classes.hiddenWhenEmptyValue, classes.textField].join(' ') : classes.textField}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    id="CompanyZip"
                                    label="Company Zip"
                                    value={company.CompanyZip}
                                    onChange={this.handleChange('CompanyZip')}
                                    {...sharedTextFieldProps}
                                    className={(company.CompanyZip === (undefined || '') && view_type === 'detail') ? [classes.hiddenWhenEmptyValue, classes.textField].join(' ') : classes.textField}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    id="CompanyPhone"
                                    label="Company Phone"
                                    value={company.CompanyPhone}
                                    onChange={this.handleChange('CompanyPhone')}
                                    {...sharedTextFieldProps}
                                    className={(company.CompanyPhone === (undefined || '') && view_type === 'detail') ? [classes.hiddenWhenEmptyValue, classes.textField].join(' ') : classes.textField}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    type="text"
                                    id="CompanyEmail"
                                    label="Company Email"
                                    value={company.CompanyEmail}
                                    onChange={this.handleChange('CompanyEmail')}
                                    {...sharedTextFieldProps}
                                />
                                </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    id="CompanyWebAddress"
                                    label="Company Web Address"
                                    value={company.CompanyWebAddress}
                                    onChange={this.handleChange('CompanyWebAddress')}
                                    {...sharedTextFieldProps}
                                    className={(company.CompanyWebAddress === (undefined || '') && view_type === 'detail') ? [classes.hiddenWhenEmptyValue, classes.textField].join(' ') : classes.textField}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    id="CompanyBillingContactName"
                                    label="Company Billing Contact Name"
                                    value={company.CompanyBillingContactName}
                                    onChange={this.handleChange('CompanyBillingContactName')}
                                    {...sharedTextFieldProps}
                                    className={(company.CompanyBillingContactName === (undefined || '') && view_type === 'detail') ? [classes.hiddenWhenEmptyValue, classes.textField].join(' ') : classes.textField}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    id="CompanyBillingContactPhone"
                                    label="Company Billing Contact Phone"
                                    value={company.CompanyBillingContactPhone}
                                    onChange={this.handleChange('CompanyBillingContactPhone')}
                                    {...sharedTextFieldProps}
                                    className={(company.CompanyBillingContactPhone === (undefined || '') && view_type === 'detail') ? [classes.hiddenWhenEmptyValue, classes.textField].join(' ') : classes.textField}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    id="CompanyBillingContactEmail"
                                    label="Company Billing Contact Email"
                                    value={company.CompanyBillingContactEmail}
                                    onChange={this.handleChange('CompanyBillingContactEmail')}
                                    {...sharedTextFieldProps}
                                    className={(company.CompanyBillingContactEmail === (undefined || '') && view_type === 'detail') ? [classes.hiddenWhenEmptyValue, classes.textField].join(' ') : classes.textField}
                                />
                            </Grid>
                        </form>
                    </Grid>
                </Grid>
            </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getCompany: Actions.getCompany,
        saveCompany: Actions.saveCompany,
        deleteCompany: Actions.deleteCompany,
        toggleInstructor: Actions.toggleInstructor,
        toggleMajor: Actions.toggleMajor,
        updateCompanyForm: Actions.updateCompanyForm,
        runValidator: validatorActions.runValidator
    }, dispatch)
}

function mapStateToProps({ companyApp, validator }) {
    return {
        company: companyApp.companies.currentCompany,
        validator: validator.list
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(CompanyForm)));



// WEBPACK FOOTER //
// src/main/content/company/CompanyForm.js